import '../styles/main.scss';

import React, {useContext} from 'react';
import Context from '../context/Context';
import {SwitchTransition, Transition} from 'react-transition-group';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import Analytics from './Analytics';
import Header from './Header';
import Footer from './Footer';

export const TRANSITION_DURATION = 400;

const TRANSITION_STYLES = {
	default: {
		transition: `opacity ${TRANSITION_DURATION}ms ease`,
	},
	entering: {
		opacity: 0,
	},
	entered: {
		opacity: 1,
	},
	exiting: {
		opacity: 0,
	},
	exited: {
		opacity: 0,
	},
};

const Layout = ({children, pageContext = {}, location}) => {
	const {header, footer, passwordProtection} = pageContext;
	const {isCartOpen, setCartOpen} = useContext(Context);

	return (
		<React.Fragment>
			<Helmet defaultTitle="Pasque Official" />
			<Helmet>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1.0"
				/>
			</Helmet>
			<Analytics
				googleAnalyticsPropertyId={
					process.env.GATSBY_GOOGLE_ANALYTICS_PROPERTY
				}
				gtmPropertyId={process.env.GATSBY_GTM_PROPERTY}
				klaviyoCompanyId={process.env.GATSBY_KLAVIYO_COMPANY_ID}
			/>
			<a
				name="maincontent"
				className="fix top left z10 skip"
				href="#maincontent">
				Skip to main content
			</a>
			<SwitchTransition>
				<Transition
					key={location.pathname}
					mountOnEnter
					unmountOnExit
					appear
					timeout={TRANSITION_DURATION}>
					{status => (
						<div
							id="maincontent"
							style={{
								...TRANSITION_STYLES.default,
								...TRANSITION_STYLES[status],
							}}>
							{children}
						</div>
					)}
				</Transition>
			</SwitchTransition>
		</React.Fragment>
	);
};

export default Layout;
